"use client";

import { BProgress } from "@bprogress/core";
import { useRouter } from "next/navigation";

export function useProgressRouter() {
  const router = useRouter();

  // Only call BProgress on client-side
  if (typeof window !== "undefined") {
    BProgress.remove();
  }

  const push = async (...args: Parameters<typeof router.push>) => {
    if (typeof window !== "undefined") {
      BProgress.start();
    }
    try {
      await router.push(...args);
    } finally {
      if (typeof window !== "undefined") {
        BProgress.remove();
      }
    }
  };

  const replace = async (...args: Parameters<typeof router.replace>) => {
    if (typeof window !== "undefined") {
      BProgress.start();
    }
    try {
      await router.replace(...args);
    } finally {
      if (typeof window !== "undefined") {
        BProgress.remove();
      }
    }
  };

  return { ...router, push, replace };
}
